module.exports = __webpack_public_path__ + "images/sample-dd91a57b2b3d96b000f3603715c02c5a.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/sample.png
// module id = 211
// module chunks = 0